import { FormCondition } from '@types';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _get from 'lodash/get';

export const checkIsVisible = (form, conditions: FormCondition[]) => {
  if (_isEmpty(conditions)) {
    return true;
  }
  return conditions.some((condition) => _isEqual(_get(form, condition.path), condition.equal));
};
